import { render } from "./ServiceMenu.vue?vue&type=template&id=bcb433bc&scoped=true"
import script from "./ServiceMenu.vue?vue&type=script&lang=js"
export * from "./ServiceMenu.vue?vue&type=script&lang=js"

import "./ServiceMenu.vue?vue&type=style&index=0&id=bcb433bc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcb433bc"],['__file',"src/components/header/ServiceMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bcb433bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bcb433bc', __exports__)) {
    api.reload('bcb433bc', __exports__)
  }
  
  module.hot.accept("./ServiceMenu.vue?vue&type=template&id=bcb433bc&scoped=true", () => {
    api.rerender('bcb433bc', render)
  })

}


export default __exports__